import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DataStateChangeEvent, GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { process, GroupDescriptor } from '@progress/kendo-data-query';
export class PageGrid {
  private kendoGridComponent?: GridComponent;
  gridView: GridDataResult;
  gridQuery: ListQuery;
  refreshDataInProgress = false;
  refreshPageInProgress = false;
  filtersForm: FormGroup;
  pagination = { buttonCount: 5, info: true, type: 'numeric', pageSizes: [5, 10, 50, 100], previousNext: false, responsive: false };
  initialDataLoaded = false;

  private fetchTotal: (ListQuery) => Promise<{ data: number }>;
  private fetchPage: (ListQuery) => Promise<{ data: any[] }>;

  constructor(private fb: FormBuilder, pageSize = 10) {
    this.gridView = { data: [], total: 0 };
    this.gridQuery = new ListQuery(pageSize);
  }

  setFilters(filtersFormControls) {
    let previousFilterValues;
    this.filtersForm = this.fb.group(filtersFormControls);
    this.filtersForm.valueChanges
      .pipe(debounceTime(200))
      .pipe(distinctUntilChanged())
      .subscribe((values) => {
        let currentFilterValues = JSON.stringify(values);
        if (previousFilterValues !== currentFilterValues) {
          previousFilterValues = currentFilterValues;
          this.gridQuery.filterValues = values;
          this.gridQuery.skip = 0;
          this.resetAndRefreshData();
        }
      });
    this.gridQuery.filterValues = this.filtersForm.value;
    this.loadInitialData();
    return this;
  }

  setSources(fetchTotal: (ListQuery) => Promise<{ data: number }>, fetchPage: (ListQuery) => Promise<{ data: any[] }>) {
    this.fetchTotal = fetchTotal;
    this.fetchPage = fetchPage;
    this.loadInitialData();
    return this;
  }

  gridStateChanged({ skip, take, sort }: DataStateChangeEvent) {
    this.gridQuery.skip = skip;
    this.gridQuery.take = take;
    this.gridQuery.sort = sort as any;
    if (sort && sort[0] && sort[0].field) {
      this.gridQuery.sortField = `${(sort && sort[0] && sort[0].field) || ''},${(sort && sort[0] && sort[0].dir) || ''}`;
    }
    this.resetAndRefreshData();
    // this.refreshPage();
    return this;
  }
  refreshData() {
    this.refreshDataInProgress = true;
    this.gridQuery.refreshDataInProgress = true;
    this.gridView = { data: [], total: 0 };
    return this.fetchTotal(this.gridQuery).then(({ data: count }) => {
      this.refreshDataInProgress = false;
      this.gridQuery.refreshDataInProgress = false;
      this.gridQuery.total = count;
      this.gridView.total = count;
      this.refreshPage();
    });
  }

  refreshPage() {
    this.gridView.data = [];
    this.refreshPageInProgress = true;
    this.fetchPage(this.gridQuery).then(({ data }) => {
      this.refreshPageInProgress = false;
      this.gridView.data = data;
    });
  }
  async resetAndRefreshData() {
    return this.refreshData();
  }

  loadInitialData() {
    if (!this.initialDataLoaded && this.refreshPage && this.filtersForm) {
      this.resetAndRefreshData();
    }
  }
  public groupChange(groups: GroupDescriptor[]): void {
    console.log(groups);
    this.loadProducts(groups);
  }

  sortChange(sort) {
    this.gridQuery.sort = sort;
    this.gridQuery.sortField = `${(sort && sort[0] && sort[0].field) || ''},${(sort && sort[0] && sort[0].dir) || ''}`;
    this.resetAndRefreshData();
  }
  loadProducts(groups): void {
    this.fetchPage(this.gridQuery).then(({ data }) => {
      this.refreshPageInProgress = false;
      this.gridView = process(data, { group: groups });
    });
  }
}

export class ListQuery {
  sortField?: string;
  take?: number;
  skip?: number;
  refreshDataInProgress: boolean;
  sort = [
    {
      field: '',
      dir: '',
    },
  ];
  total?: number;
  filterValues?: any;

  get page() {
    return this.skip / this.take;
  }

  get size() {
    return this.take;
  }

  constructor(take) {
    this.skip = 0;
    this.take = take;
  }
}
